import {useQuery} from '@tanstack/react-query';
import {useSelector} from 'react-redux';

import {ENDPOINTS} from 'constants/endpoints';
import {apiConfig} from 'libs/api/api';

import {getOrderItems} from '../store/selectors/orderStatus/orderStatus';

type EyeExamType = {
    itemId: number;
    status: string;
};

/**
 * Fetches eye exams list
 */
export const useFetchEyeExams = () => {
    const orderItems = useSelector(getOrderItems);
    const isDesktop = __BUILD_TYPE__ === 'desktop';

    return useQuery({
        enabled: isDesktop,
        queryFn: () =>
            apiConfig.instanceGusaBackend.request<EyeExamType[]>({
                method: 'get',
                url: ENDPOINTS.EXAM,
            }),
        queryKey: ['GET_EYE_EXAMS', orderItems],
        staleTime: 300000,
    });
};
